// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"967e103d","219":"296b4a7c","455":"399606b7","555":"f746b6e7","797":"16a6b632","852":"efabf713","910":"1f8af80f","936":"ccec74a8","977":"8c72bf08"}[chunkId] + ".chunk.js";
};